import React from 'react';
import styled, { css } from 'styled-components';

const IconContainer = styled.div`
    width: ${({ size = '90' }) => size}px;
    height: ${({ size = '90' }) => size}px;
    margin: ${({ margin = '0' }) => margin}px;
    ${({ border }) => border && css`border: ${border};`}
    background-color: ${({ color = '#eaeaea' }) => color};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
`;

export default IconContainer;
